import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams, Link} from 'react-router-dom';
import PageBase from "../../../components/PageBase/index";
import Field from "../../../components/FieldGroup/Field/index";
import bullet from '../../../assets/title-bullet.png';
import * as programActions from "../../../redux/Program/actions";
import * as ROUTES from "../../../utils/routes";
import FieldGroup from "../../../components/FieldGroup";

import './EditProgram.scss';
import ObjectSummaryRow from "../../../components/ObjectSummaryRow";

const EditProgram = props => {
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();
	const params = useParams();
	const program = useSelector(state => state.program.programs?.find(pr => pr.Id === params.id));

	useEffect(() => {
		const load = async () => {
			if(program == null) {
				dispatch(programActions.loadProgramById(params.id))
			}
		};
		load();
	}, [program, params.id]);

	if(program == null) {
		return <div/>;
	}


	const summary = [
		{ title: 'Priority', value: program.Priority__c, blue: true},
		{ title: 'Status', value: program.Status__c},
		{ title: 'Next Step', value: program.Next_Step__c},
		{ title: 'Expiration Date', value: program.Expiration_Date__c}
	];

	return (
		<PageBase title="Program"
		          removeMargins
		          bodyBg="#fff"
		          headerLinkText="All Programs"
		          headerLinkTarget={ROUTES.PROGRAMS}
		>
			<div className="edit-program-title">
				<img src={bullet} style={{width: '24px', marginRight: '20px'}} />
				<span>{program.Name}</span>
			</div>

			<ObjectSummaryRow data={summary} />

			<div style={{height: '100%', overflowY: 'auto', padding: '0 20px'}}>
				<FieldGroup title="Details" expandable expanded>
					<Field title="Program Owner" highlight>{program.Owner?.Name}</Field>
					<Field title="Program Name">{program.Name}</Field>

					<Field title="Account Name">{program.Account_Name__r?.Name}</Field>
					<Field title="Cloud Provider">{program.Cloud_Provider__c}</Field>

					<Field title="Program Type">{program.Program__c}</Field>
					<Field title="Priority">{program.Priority__c}</Field>

					<Field title="Integrated Service">{program.Integrated_Service__c}</Field>
					<Field title="Competency">{program.Competency__c}</Field>

					<Field title="Status">{program.Status__c}</Field>
					<Field title="Progress">{program.Progress__c}</Field>

					<Field title="Due Date">{program.Due_Date__c}</Field>
					<Field title="Expiration Date">{program.Expiration_Date__c}</Field>

					<Field title="Description">{program.Description__c}</Field>
					<Field title="Last Status Update Date">{program.Last_Status_Update_Date__c}</Field>

					<Field title="Actual Date">{program.Actual_Date__c}</Field>
				</FieldGroup>

				<FieldGroup title="Activity" expandable>
					<Field title="Next Step">{program.Next_Step__c}</Field>
					<Field title="Next Step Date">{program.Next_Step_Date__c}</Field>

					<Field title="Next Step POC">{program.Next_Step_POC__r?.Name}</Field>
					<Field title="Next Step Owner">{program.Next_Step_Owner__r?.Name}</Field>
				</FieldGroup>

				<FieldGroup title="System Information" expandable>
					<Field title="Created By">{program.CreatedBy.Name}</Field>
					<Field title="Last Modified By">{program.LastModifiedBy.Name}</Field>
				</FieldGroup>
			</div>
		</PageBase>
	)
};

export default EditProgram;
